import Carousel from 'react-bootstrap/Carousel'
import { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useDispatch, useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close';
import { fetchCompanyBanners } from '../../../redux/bannerSlice';
import { closeBanner } from '../../../redux/authSlice';
import './styles.css';

const BannerCarousal = ({ show }) => {
    const banners = useSelector((state) => state.banners.data)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(fetchCompanyBanners())
    }, [])

    return (
        <div>
            {banners.length > 0 ? <Modal show={show} closeButton size='lg'>
                <div className='clays-sm' style={{ backgroundColor: '#f9fbf7', display: 'flex', justifyContent: 'flex-end' }}>
                    <button className='icon-clay' onClick={() => dispatch(closeBanner())}>
                        <span class="-clay color-black">
                            <CloseIcon />
                        </span>
                    </button>
                </div>

                <Carousel variant='dark' >
                    {
                        banners.map((banner) => (
                            <Carousel.Item>
                                <div className='banner-view-stage' style={{
                                    height: '500px',
                                    padding: "10px",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    backgroundColor: '#f9fbf7',
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <p dangerouslySetInnerHTML={{ __html: banner.bannerHeader }} style={{
                                            fontFamily: "Lato",
                                            fontSize: "25px",
                                            fontWeight: 600,
                                            marginLeft: '60px'
                                        }}></p>
                                    </div>

                                    <p dangerouslySetInnerHTML={{ __html: banner.bannerText }} style={{
                                        fontFamily: "Lato",
                                        fontSize: "18px",
                                        fontWeight: 400,
                                        marginLeft: '60px'
                                    }}></p>
                                    <img src={'http://localhost:3200/' + banner.bannerImagePath} className='banner_pop_image' alt="NO IMAGE" />
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
            </Modal> : null}
        </div>
    )
}

export default BannerCarousal